import { Controller, useFormContext } from 'react-hook-form';
import { FC } from 'react';

import { CollapseCheckbox } from '../components/collapseCheckbox';
import { KjelVannbarenVarme } from '../components/kjelVannbarenVarme';
import { AboutFormControlProps, AboutFormData } from '../../types';
import { JaNeiVetIkke, OppvarmingBruk, Varmesentral } from '../../../../../utils/registerEnums';

const kjelDefaultValue = {
  bruk: OppvarmingBruk.Ukjent,
  varmesentral: Varmesentral.Ukjent,
  serviceGjennomfortSiste2Ar: JaNeiVetIkke.VetIkke
};

export const Kjel: FC<AboutFormControlProps> = ({ control }) => {
  const { setValue } = useFormContext<AboutFormData>();
  return (
    <Controller
      name="oppvarming.oppvarmingElektrisk.kjel.selected"
      control={control}
      render={({ field, fieldState }) => (
        <CollapseCheckbox
          labelKey="register.tekniskUtstyr.kjel.label"
          helperTextKey="register.tekniskUtstyr.kjel.helperText"
          checked={!!field.value}
          onChange={(checked) => {
            field.onChange(checked);

            const kjelValue = !field.value ? kjelDefaultValue : undefined;
            setValue('oppvarming.oppvarmingElektrisk.kjel.value', kjelValue);
          }}
          error={!!fieldState.error}
        >
          <KjelVannbarenVarme name="oppvarming.oppvarmingElektrisk.kjel.value" control={control} />
        </CollapseCheckbox>
      )}
    />
  );
};
